  function setActiveMedia(mediaRoot, mediaId) {
    if (!mediaRoot || !mediaId) return;
    const scroller = mediaRoot.querySelector('[data-media-main]');
    const item = scroller ? scroller.querySelector(`[data-media-id="${mediaId}"]`) : null;
    if (item) {
      // A plain scrollLeft assignment is used instead of scrollIntoView()/scrollTo()
      // with smooth behavior: combined with scroll-snap-type, smooth programmatic
      // scrolling does not reliably animate the container in every browser.
      scroller.scrollLeft = item.offsetLeft;
      // Also drives the gallery's own height (see --media-active-ratio in
      // the stylesheet above) — a thumbnail click or a color-row sync
      // jumping to a differently-proportioned photo resizes the container
      // just like a manual swipe does via the IntersectionObserver below.
      scroller.style.setProperty('--media-active-ratio', item.getAttribute('data-media-ratio') || '1');
    }
    mediaRoot.querySelectorAll('[data-media-thumbnail]').forEach((thumb) => {
      thumb.classList.toggle('is-selected', thumb.getAttribute('data-media-id') === String(mediaId));
    });
  }

  document.querySelectorAll('.product__media').forEach((mediaRoot) => {
    const scroller = mediaRoot.querySelector('[data-media-main]');
    const thumbnails = mediaRoot.querySelectorAll('[data-media-thumbnail]');
    if (!scroller || !thumbnails.length) return;

    // Keeps the thumbnail highlight — and the gallery's own height, via
    // --media-active-ratio (see the stylesheet above) — in sync when the
    // shopper swipes the gallery by hand instead of clicking a thumbnail.
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const id = entry.target.getAttribute('data-media-id');
          thumbnails.forEach((thumb) => {
            thumb.classList.toggle('is-selected', thumb.getAttribute('data-media-id') === id);
          });
          scroller.style.setProperty('--media-active-ratio', entry.target.getAttribute('data-media-ratio') || '1');
        });
      },
      { root: scroller, threshold: 0.6 }
    );
    scroller.querySelectorAll('[data-media-item]').forEach((item) => observer.observe(item));
  });

  // Thumbnail strip prev/next arrows: same plain-scrollLeft technique as
  // ugcScrollByItem in sections/ugc-carousel.liquid (scroll-snap + smooth
  // programmatic scrolling doesn't reliably animate in every browser).
  function scrollThumbnailsByOne(track, direction) {
    const thumb = track.querySelector('.product__thumbnail');
    if (!thumb) return;
    const thumbWidth = thumb.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    track.scrollLeft += direction * (thumbWidth + gap);
  }

  document.querySelectorAll('.product__thumbnails-wrap').forEach((wrap) => {
    const track = wrap.querySelector('[data-media-thumbnails]');
    const prevButton = wrap.querySelector('[data-thumbnails-prev]');
    const nextButton = wrap.querySelector('[data-thumbnails-next]');
    if (!track) return;

    if (prevButton) prevButton.addEventListener('click', () => scrollThumbnailsByOne(track, -1));
    if (nextButton) nextButton.addEventListener('click', () => scrollThumbnailsByOne(track, 1));
  });

  function getVariantsData(form) {
    const variantsScript = form.querySelector('[data-product-variants]');
    return variantsScript ? JSON.parse(variantsScript.textContent) : [];
  }

  function resolveVariant(variantsData, selections) {
    return variantsData.find((variant) =>
      Object.keys(selections).every((position) => variant['option' + position] === selections[position])
    );
  }

  // Derived once from two [data-bundle-tiers] reference values, each
  // rendered server-side through Shopify's own | money filter — which is
  // correctly market/currency-aware, unlike a hardcoded '€' would be. The
  // small sample (1,00) exposes the decimal separator + prefix/suffix; the
  // large sample (1.000.000,00) exposes the thousands separator, which a
  // single-digit sample can't reveal. Falls back to a bare € format only
  // if the reference attributes are missing entirely (defensive, should
  // not happen given the Liquid always renders them).
  function parseMoneyFormat(bundleRoot) {
    const fallback = { prefix: '€', suffix: '', decimalSep: ',', thousandSep: '.' };
    if (!bundleRoot) return fallback;

    const small = bundleRoot.getAttribute('data-money-format-small') || '';
    const large = bundleRoot.getAttribute('data-money-format-large') || '';
    const smallMatch = small.match(/^(\D*)(\d+)(\D)(\d{2})(\D*)$/);
    if (!smallMatch) return fallback;

    const [, prefix, , decimalSep, , suffix] = smallMatch;
    const core = large.slice(prefix.length, large.length - suffix.length);
    const wholePart = core.slice(0, Math.max(core.length - 3, 0));
    const thousandSepMatch = wholePart.match(/\D/);

    return {
      prefix,
      suffix,
      decimalSep,
      thousandSep: thousandSepMatch ? thousandSepMatch[0] : '',
    };
  }

  const moneyFormat = parseMoneyFormat(document.querySelector('[data-bundle-tiers]'));

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    const [whole, decimals] = amount.split('.');
    const wholeGrouped = moneyFormat.thousandSep
      ? whole.replace(/\B(?=(\d{3})+(?!\d))/g, moneyFormat.thousandSep)
      : whole;
    return moneyFormat.prefix + wholeGrouped + moneyFormat.decimalSep + decimals + moneyFormat.suffix;
  }

  // Single source of truth for "which tier is active": the checked radio,
  // not a JS-managed class — the card's visuals (background/border, its own
  // rows showing) are driven purely by CSS :has(:checked), so there's
  // nothing to keep in sync here.
  function getActiveTier(form) {
    const checkedRadio = form.querySelector('[data-bundle-tier-radio]:checked');
    return checkedRadio ? checkedRadio.closest('[data-bundle-tier]') : null;
  }

  // Estimates every tier card's total/original/savings/per-unit price from
  // the currently selected single variant's price — a comparison aid shown
  // before/between pack choices. Once a multi-unit tier is active,
  // updateActiveTierRealPricing overwrites that one tier's own numbers with
  // the real total from each row's own resolved variant.
  function updateTierPricing(form) {
    const variantIdInput = form.querySelector('[data-variant-id-input]');
    const currentVariant = getVariantsData(form).find((variant) => String(variant.id) === variantIdInput.value);
    if (!currentVariant) return;

    const bundleRoot = form.querySelector('[data-bundle-tiers]');
    if (!bundleRoot) return;
    const savingsTemplate = bundleRoot.getAttribute('data-savings-label-template') || 'Save {amount}';
    const perUnitTemplate = bundleRoot.getAttribute('data-per-unit-template') || 'Only {price} each';

    form.querySelectorAll('[data-bundle-tier]').forEach((tierButton) => {
      const radio = tierButton.querySelector('[data-bundle-tier-radio]');
      const quantity = Number(radio.getAttribute('data-quantity')) || 1;

      const originalCents = currentVariant.price * quantity;
      // A tier with a merchant-entered custom_price (see the Liquid above)
      // carries this attribute with the fixed total already in cents —
      // takes priority over the discount-percentage math below, which
      // still runs unchanged for every tier that leaves custom_price
      // blank. custom_price is a flat amount, not converted per market —
      // safe only for a single-currency store (see the field's own info
      // text in the theme editor).
      let totalCents;
      let discountCents;
      if (radio.hasAttribute('data-custom-price-cents')) {
        totalCents = Number(radio.getAttribute('data-custom-price-cents')) || 0;
        discountCents = Math.max(0, originalCents - totalCents);
      } else {
        const discount = Number(radio.getAttribute('data-discount')) || 0;
        discountCents = Math.round((originalCents * discount) / 100);
        totalCents = originalCents - discountCents;
      }
      const perUnitCents = Math.round(totalCents / quantity);

      const totalEl = tierButton.querySelector('[data-bundle-total-price]');
      if (totalEl) totalEl.textContent = formatMoney(totalCents);

      const originalEl = tierButton.querySelector('[data-bundle-original-price]');
      if (originalEl) originalEl.textContent = formatMoney(originalCents);

      const savingsEl = tierButton.querySelector('[data-bundle-savings]');
      if (savingsEl) savingsEl.textContent = savingsTemplate.replace('{amount}', formatMoney(discountCents));

      const perUnitEl = tierButton.querySelector('[data-bundle-per-unit]');
      if (perUnitEl) perUnitEl.textContent = perUnitTemplate.replace('{price}', formatMoney(perUnitCents));
    });
  }

  function resolveRowVariant(variantsData, row) {
    const selections = {};
    row.querySelectorAll('[data-bundle-row-option]').forEach((select) => {
      selections[select.getAttribute('data-option-position')] = select.value;
    });
    return resolveVariant(variantsData, selections);
  }

  // Updates a row's thumbnail to match its color <select>, using the
  // color-value → image map captured server-side (same per-color image
  // already used for the swatch buttons in 5a).
  function updateRowImage(form, row) {
    const imagesScript = form.querySelector('[data-bundle-color-images]');
    const img = row.querySelector('[data-bundle-row-image]');
    if (!imagesScript || !img) return;

    const imagesMap = JSON.parse(imagesScript.textContent);
    row.querySelectorAll('[data-bundle-row-option]').forEach((select) => {
      if (imagesMap[select.value]) img.src = imagesMap[select.value];
    });
  }

  // Sums the real resolved variant price of every row in the active tier
  // (falling back to the base variant's price for a row that doesn't
  // resolve yet) and applies that tier's discount, overwriting its own
  // total/original/savings/per-unit with the real numbers for what's about
  // to be added to cart — replacing updateTierPricing's estimate for that
  // one card only. Runs for every tier, including 1x (a single row), so
  // its total always reflects that row's own resolved variant price.
  function updateActiveTierRealPricing(form) {
    const activeTier = getActiveTier(form);
    if (!activeTier) return;

    const radio = activeTier.querySelector('[data-bundle-tier-radio]');
    const quantity = Number(radio.getAttribute('data-quantity')) || 1;

    const variantsData = getVariantsData(form);
    const variantIdInput = form.querySelector('[data-variant-id-input]');
    const fallbackVariant = variantsData.find((variant) => String(variant.id) === variantIdInput.value);

    let originalCents = 0;
    activeTier.querySelectorAll('[data-bundle-row]').forEach((row) => {
      const resolved = resolveRowVariant(variantsData, row);
      originalCents += resolved ? resolved.price : fallbackVariant ? fallbackVariant.price : 0;
    });

    // Same custom_price override as updateTierPricing above: a fixed total
    // wins over the discount-percentage math when set.
    let totalCents;
    let discountCents;
    if (radio.hasAttribute('data-custom-price-cents')) {
      totalCents = Number(radio.getAttribute('data-custom-price-cents')) || 0;
      discountCents = Math.max(0, originalCents - totalCents);
    } else {
      const discount = Number(radio.getAttribute('data-discount')) || 0;
      discountCents = Math.round((originalCents * discount) / 100);
      totalCents = originalCents - discountCents;
    }
    const perUnitCents = Math.round(totalCents / quantity);

    const bundleRoot = form.querySelector('[data-bundle-tiers]');
    const savingsTemplate = bundleRoot.getAttribute('data-savings-label-template') || 'Save {amount}';
    const perUnitTemplate = bundleRoot.getAttribute('data-per-unit-template') || 'Only {price} each';

    const totalEl = activeTier.querySelector('[data-bundle-total-price]');
    if (totalEl) totalEl.textContent = formatMoney(totalCents);

    const originalEl = activeTier.querySelector('[data-bundle-original-price]');
    if (originalEl) originalEl.textContent = formatMoney(originalCents);

    const savingsEl = activeTier.querySelector('[data-bundle-savings]');
    if (savingsEl) savingsEl.textContent = savingsTemplate.replace('{amount}', formatMoney(discountCents));

    const perUnitEl = activeTier.querySelector('[data-bundle-per-unit]');
    if (perUnitEl) perUnitEl.textContent = perUnitTemplate.replace('{price}', formatMoney(perUnitCents));
  }

  // Disables "add to cart" while any of the active tier's rows doesn't
  // resolve to an available variant. Runs for every tier, including 1x.
  function updateBundleAvailability(form) {
    const activeTier = getActiveTier(form);
    if (!activeTier) return;

    const variantsData = getVariantsData(form);
    const submitButton = form.querySelector('[data-add-to-cart]');
    let allAvailable = true;
    activeTier.querySelectorAll('[data-bundle-row]').forEach((row) => {
      const resolved = resolveRowVariant(variantsData, row);
      if (!resolved || !resolved.available) allAvailable = false;
    });

    submitButton.disabled = !allAvailable;
    submitButton.textContent = allAvailable
      ? submitButton.getAttribute('data-add-text')
      : submitButton.getAttribute('data-sold-out-text');
  }

  function refreshActiveTier(form) {
    updateActiveTierRealPricing(form);
    updateBundleAvailability(form);
  }

  // Marks each standalone color swatch / size button as unavailable
  // (.is-unavailable — still clickable, just dimmed + struck through/
  // diagonal-lined via CSS) when no variant combining that value with
  // whatever the OTHER standalone control currently has selected is in
  // stock. Reads variant.available straight from variants_json (the same
  // data resolveVariant() already uses), not a hand-maintained list, so it
  // can't drift out of sync with real inventory. Bidirectional: picking a
  // color re-checks which sizes are available in that color, and picking a
  // size re-checks which colors are available in that size — with neither
  // selected yet, a value counts as available if any variant with it is,
  // regardless of the other option.
  function updateOptionAvailability(form) {
    const variantsData = getVariantsData(form);
    const colorSwatch = form.querySelector('[data-product-color-swatch]');
    const sizeButton = form.querySelector('[data-product-size-button]');
    const colorPosition = colorSwatch ? colorSwatch.getAttribute('data-option-position') : null;
    const sizePosition = sizeButton ? sizeButton.getAttribute('data-option-position') : null;

    const selectedColor = form.querySelector('.is-selected[data-product-color-swatch]')?.getAttribute('data-option-value') || null;
    const selectedSize = form.querySelector('.is-selected[data-product-size-button]')?.getAttribute('data-option-value') || null;

    function isValueAvailable(position, value, otherPosition, otherValue) {
      return variantsData.some((variant) => {
        if (variant['option' + position] !== value) return false;
        if (otherPosition && otherValue && variant['option' + otherPosition] !== otherValue) return false;
        return variant.available;
      });
    }

    if (colorPosition) {
      form.querySelectorAll('[data-product-color-swatch]').forEach((swatch) => {
        const value = swatch.getAttribute('data-option-value');
        const available = isValueAvailable(colorPosition, value, sizePosition, selectedSize);
        swatch.classList.toggle('is-unavailable', !available);
      });
    }

    if (sizePosition) {
      form.querySelectorAll('[data-product-size-button]').forEach((button) => {
        const value = button.getAttribute('data-option-value');
        const available = isValueAvailable(sizePosition, value, colorPosition, selectedColor);
        button.classList.toggle('is-unavailable', !available);
      });
    }
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    updateTierPricing(form);
    refreshActiveTier(form);
    updateOptionAvailability(form);
  });

  document.addEventListener('change', (event) => {
    const radio = event.target.closest('[data-bundle-tier-radio]');
    if (!radio) return;

    const form = radio.closest('[data-product-form]');
    if (!form) return;

    const quantity = Number(radio.getAttribute('data-quantity')) || 1;
    const quantityInput = form.querySelector('[data-bundle-quantity-input]');
    if (quantityInput) quantityInput.value = quantity;

    refreshActiveTier(form);
  });

  document.addEventListener('change', (event) => {
    const rowSelect = event.target.closest('[data-bundle-row-option]');
    if (!rowSelect) return;

    const form = rowSelect.closest('[data-product-form]');
    const row = rowSelect.closest('[data-bundle-row]');
    if (!form || !row) return;

    updateRowImage(form, row);
    refreshActiveTier(form);

    // Main gallery: switch to this row's newly resolved variant's own
    // photo, using featured_media_id already captured in variants_json —
    // the same data source setActiveMedia already uses for thumbnail
    // clicks, just triggered from inside a bundle row. This intentionally
    // does NOT touch the standalone color swatch above (see its own click
    // handler) — a shopper overriding one row's color individually should
    // not reset what the swatch shows as the main/last choice, and should
    // not affect any other row either: only the standalone swatch/size
    // finder trigger the all-tiers sync below, a single row's own select
    // changes only that row.
    const variantsData = getVariantsData(form);
    const resolved = resolveRowVariant(variantsData, row);
    if (resolved && resolved.featured_media_id) {
      const mediaRoot = form.closest('.product__inner')?.querySelector('.product__media');
      setActiveMedia(mediaRoot, resolved.featured_media_id);
    }
  });

  function applyVariantFromSelection(form) {
    const selected = {};
    form.querySelectorAll('.is-selected[data-option-position]').forEach((control) => {
      selected[control.getAttribute('data-option-position')] = control.getAttribute('data-option-value');
    });

    const matchedVariant = resolveVariant(getVariantsData(form), selected);
    if (!matchedVariant) return;

    form.querySelector('[data-variant-id-input]').value = matchedVariant.id;

    const infoColumn = form.closest('.product__info') || form;
    infoColumn.querySelectorAll('[data-variant-price]').forEach((panel) => {
      panel.hidden = panel.getAttribute('data-variant-id') !== String(matchedVariant.id);
    });

    const meta = form.querySelector(`[data-variant-meta][data-variant-id="${matchedVariant.id}"]`);
    const submitButton = form.querySelector('[data-add-to-cart]');
    const isAvailable = meta ? meta.getAttribute('data-available') === 'true' : false;
    submitButton.disabled = !isAvailable;
    submitButton.textContent = isAvailable
      ? submitButton.getAttribute('data-add-text')
      : submitButton.getAttribute('data-sold-out-text');

    const mediaId = meta ? meta.getAttribute('data-featured-media-id') : '';
    const mediaRoot = document.querySelector('.product__media');
    if (mediaId) setActiveMedia(mediaRoot, mediaId);

    updateTierPricing(form);
  }

  // The old generic [data-option-value] click handler that lived here
  // (shared by the top-level size buttons and, before that, the top-level
  // swatch) is gone along with the size buttons themselves (see 5b) — the
  // standalone color swatch below has its own dedicated handler instead,
  // since its behavior branches on bundle state in a way a shared path
  // doesn't need to know about.
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-media-thumbnail]');
    if (!thumbnail) return;
    setActiveMedia(thumbnail.closest('.product__media'), thumbnail.getAttribute('data-media-id'));
  });

  // Pushes a new option value into every bundle tier's own row selects for
  // that option position — not just the active tier's, so whichever tier
  // the shopper switches to next already has the right value waiting,
  // without them having to reselect it per tier. Scoped to the whole form
  // (every tier lives inside it) rather than getActiveTier() specifically,
  // which is what makes this "all tiers" instead of "just the one
  // currently showing".
  //
  // Called only from the standalone color swatch and standalone size
  // buttons below (plus the size finder's own findMatch(), which does its
  // own equivalent form-wide row matching rather than calling this
  // directly — see its comment) — deliberately NOT from a bundle row's own
  // [data-bundle-row-option] change handler, so a shopper editing one
  // row's own select only ever changes that row, never the others. Only
  // the two standalone "primary choice" controls (and the size finder)
  // are allowed to fan a value out to every row/tier.
  function syncOptionToAllTiers(form, position, value) {
    form
      .querySelectorAll(`[data-bundle-row-option][data-option-position="${position}"]`)
      .forEach((select) => {
        if (select.value === value) return;
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
  }

  // Standalone color swatch: the single primary color input for the whole
  // product (see the comment on its markup for the full rationale). With
  // a bundle tier active, push the new color into every tier's own row
  // selects via syncOptionToAllTiers, dispatching a real change so the
  // existing [data-bundle-row-option] handler above does row image/price/
  // gallery for each — deliberately one-directional, a row's own select
  // changing afterwards does not reset this swatch (see that handler's
  // own comment). Without an active tier, fall back to
  // applyVariantFromSelection(), the same path a plain single-variant
  // product's top-level picker already used before this swatch replaced
  // it.
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-product-color-swatch]');
    if (!swatch) return;

    const form = swatch.closest('[data-product-form]');
    const group = swatch.closest('[data-product-color-swatches]');
    if (!form || !group) return;

    group.querySelectorAll('[data-product-color-swatch]').forEach((control) => {
      control.classList.remove('is-selected');
      control.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is-selected');
    swatch.setAttribute('aria-pressed', 'true');

    const position = swatch.getAttribute('data-option-position');
    const value = swatch.getAttribute('data-option-value');

    const activeTier = getActiveTier(form);
    if (activeTier) {
      syncOptionToAllTiers(form, position, value);

      // Bundle mode has no single resolvable "variant" for this swatch
      // alone (each row picks its own size independently), so the gallery
      // switches straight to this color's own representative photo
      // instead — same setActiveMedia() every other click path here uses,
      // just keyed by color alone via color_media_ids_json.
      const mediaIdsScript = group.querySelector('[data-product-color-media-ids]');
      let mediaIds = {};
      try {
        mediaIds = mediaIdsScript ? JSON.parse(mediaIdsScript.textContent) : {};
      } catch (error) {
        mediaIds = {};
      }
      if (mediaIds[value]) {
        const mediaRoot = form.closest('.product__inner')?.querySelector('.product__media');
        setActiveMedia(mediaRoot, mediaIds[value]);
      }
    } else {
      applyVariantFromSelection(form);
    }
    updateOptionAvailability(form);
  });

  // Standalone size pill-buttons: same role, position and one-directional
  // all-tiers sync as the standalone color swatch just above (see its
  // comment for the full rationale) — mutually exclusive with the band/cup
  // finder per show_standalone_size_selector server-side, so this handler
  // and the finder's own findMatch() below never both apply to the same
  // product.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-product-size-button]');
    if (!button) return;

    const form = button.closest('[data-product-form]');
    const group = button.closest('[data-product-size-buttons]');
    if (!form || !group) return;

    group.querySelectorAll('[data-product-size-button]').forEach((control) => {
      control.classList.remove('is-selected');
      control.setAttribute('aria-pressed', 'false');
    });
    button.classList.add('is-selected');
    button.setAttribute('aria-pressed', 'true');

    const position = button.getAttribute('data-option-position');
    const value = button.getAttribute('data-option-value');

    const activeTier = getActiveTier(form);
    if (activeTier) {
      syncOptionToAllTiers(form, position, value);
    } else {
      applyVariantFromSelection(form);
    }
    updateOptionAvailability(form);
  });

  // Bra size finder: band + cup dropdowns resolve to a result size from the
  // product's size chart metafield (parsed to JSON above), shown in the
  // disabled third select for reference. findMatch() below applies the
  // matched size to every tier's own row selects (not just the active
  // one), same all-tiers reach as the standalone size buttons.
  document.querySelectorAll('[data-size-finder]').forEach((finder) => {
    const chartScript = finder.querySelector('[data-size-finder-chart]');
    let chart = [];
    try {
      chart = JSON.parse(chartScript.textContent);
    } catch (error) {
      chart = [];
    }

    const bandSelect = finder.querySelector('[data-size-finder-band]');
    const cupSelect = finder.querySelector('[data-size-finder-cup]');
    const resultSelect = finder.querySelector('[data-size-finder-result]');
    const errorEl = finder.querySelector('[data-size-finder-error]');
    const alsoFitsEl = finder.querySelector('[data-size-finder-also-fits]');
    const alsoFitsTemplate = finder.getAttribute('data-also-fits-template') || '';
    const alsoFitsAndWord = finder.getAttribute('data-also-fits-and') || 'and';
    const form = finder.closest('[data-product-form]');
    const sizeOptionPosition = finder.getAttribute('data-size-option-position');
    // Captured before the cup <select> is ever rebuilt, so the placeholder
    // text (translated, server-rendered) survives every rebuild instead of
    // being hardcoded again here.
    const cupPlaceholderText = cupSelect.querySelector('option').textContent;

    function setResult(value) {
      resultSelect.innerHTML = '';
      const option = document.createElement('option');
      option.value = value || '';
      option.textContent = value || '—';
      resultSelect.appendChild(option);
    }

    // Comma-separated, last item joined with the locale's own word for
    // "and" (data-also-fits-and, translated server-side — see
    // products.size_finder_and in the locale files) instead of a comma,
    // e.g. Danish "90E, 90F, 95B, 95C, 95D og 100B". This word was
    // previously hardcoded to Dutch "en" regardless of the active locale
    // (fixed 2026-08-20 — found showing on the Danish storefront).
    function formatCombinationList(items) {
      if (items.length <= 1) return items.join('');
      return items.slice(0, -1).join(', ') + ' ' + alsoFitsAndWord + ' ' + items[items.length - 1];
    }

    function hideAlsoFits() {
      if (!alsoFitsEl) return;
      alsoFitsEl.hidden = true;
      alsoFitsEl.textContent = '';
    }

    // Every other band+cup row in the chart that maps to this same size,
    // excluding the shopper's own just-entered combination — shown so she
    // knows the result isn't a one-off fluke tied only to her exact input.
    function showAlsoFits(size, band, cup) {
      if (!alsoFitsEl || !alsoFitsTemplate) return;

      const otherCombinations = chart
        .filter((row) => row.size === size && !(row.band === band && row.cup === cup))
        .map((row) => row.band + row.cup);

      if (!otherCombinations.length) {
        hideAlsoFits();
        return;
      }

      alsoFitsEl.textContent = alsoFitsTemplate
        .replace('{size}', size)
        .replace('{combinations}', formatCombinationList(otherCombinations));
      alsoFitsEl.hidden = false;
    }

    // Rebuilds the cup <select> from size_chart_json instead of a static
    // Liquid-rendered list, so it only ever offers cups that actually exist
    // for the chosen band (e.g. band 70 never shows a cup that has no
    // "70,<cup>,..." row) — an invalid band+cup combination becomes
    // unselectable rather than something findMatch has to reject.
    function populateCupOptions(band) {
      const previousValue = cupSelect.value;

      cupSelect.innerHTML = '';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = cupPlaceholderText;
      cupSelect.appendChild(placeholder);

      if (!band) {
        cupSelect.disabled = true;
        cupSelect.value = '';
        return;
      }

      const cupsForBand = [];
      chart.forEach((row) => {
        if (row.band === band && !cupsForBand.includes(row.cup)) cupsForBand.push(row.cup);
      });

      cupsForBand.forEach((cup) => {
        const option = document.createElement('option');
        option.value = cup;
        option.textContent = cup;
        cupSelect.appendChild(option);
      });

      cupSelect.disabled = cupsForBand.length === 0;
      // Keep the shopper's cup choice only if it's still valid for the
      // newly chosen band — otherwise a stale, now-impossible combination
      // would silently stick around.
      cupSelect.value = cupsForBand.includes(previousValue) ? previousValue : '';
    }

    function handleBandChange() {
      populateCupOptions(bandSelect.value);
      findMatch();
    }

    function findMatch() {
      const band = bandSelect.value;
      const cup = cupSelect.value;
      errorEl.hidden = true;

      if (!band || !cup) {
        setResult('');
        hideAlsoFits();
        return;
      }

      const match = chart.find((row) => row.band === band && row.cup === cup);
      if (!match || !match.size) {
        setResult('');
        errorEl.hidden = false;
        hideAlsoFits();
        return;
      }

      setResult(match.size);
      showAlsoFits(match.size, band, cup);

      const targetSize = match.size.trim().toLowerCase();

      // Apply the matched size to every row's own size <select> across
      // every tier (not just the active one — form-wide, same reach as
      // syncOptionToAllTiers), firing a native change so the existing
      // delegated [data-bundle-row-option] listener does the actual
      // variant/price resolve for each — reusing that existing handler
      // instead of duplicating its logic here. Kept as manual
      // option-matching rather than a plain
      // syncOptionToAllTiers(form, sizeOptionPosition, targetSize) call:
      // targetSize comes from the size-chart metafield's own text, which
      // isn't guaranteed to match a select option's value byte-for-byte
      // (casing, stray whitespace), so this still needs its own
      // case/whitespace-insensitive matching per select to find that
      // select's own correctly-cased option.value before assigning it.
      const rowSelects = Array.from(
        form.querySelectorAll('[data-bundle-row-option][data-option-position="' + sizeOptionPosition + '"]')
      );
      const matchedSelects = rowSelects.filter((select) =>
        Array.from(select.options).some((opt) => opt.value.trim().toLowerCase() === targetSize)
      );

      if (matchedSelects.length) {
        matchedSelects.forEach((select) => {
          const matchedOption = Array.from(select.options).find(
            (opt) => opt.value.trim().toLowerCase() === targetSize
          );
          if (select.value === matchedOption.value) return;
          select.value = matchedOption.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      } else {
        // The chart resolved a size (result readout + "also fits" text
        // above are already showing it), but that size has no matching
        // option on the actual variant selector — a chart/variant naming
        // mismatch (found 2026-08-21 on lacelift-bh: chart said "xxl",
        // the real option was "2XL"). Clearing both here instead of
        // leaving them up is what stops the result text and this error
        // from being visible at the same time. The row selects are reset
        // to no value (rather than left on whatever they showed before)
        // so resolveRowVariant() can't resolve a variant and
        // updateBundleAvailability() disables add-to-cart — better no
        // size than silently keeping a stale one the shopper never chose.
        setResult('');
        hideAlsoFits();
        errorEl.hidden = false;
        rowSelects.forEach((select) => {
          if (select.value === '') return;
          select.value = '';
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }

    bandSelect.addEventListener('change', handleBandChange);
    cupSelect.addEventListener('change', findMatch);

    // Page-load state: no band chosen yet, so the cup dropdown starts
    // empty/disabled instead of listing every cup across all bands.
    populateCupOptions(bandSelect.value);
  });

  // Site-wide sticky add-to-cart bar: visible whenever the real
  // add-to-cart button is scrolled out of view, hidden again once it's
  // back on screen — driven by IntersectionObserver instead of a scroll
  // listener so there's no manual position math and no scroll-jank.
  (function initStickyAddToCart() {
    const stickyBar = document.querySelector('[data-sticky-add-to-cart]');
    const addToCartButton = document.querySelector('[data-add-to-cart]');
    if (!stickyBar || !addToCartButton) return;

    // position: fixed takes the bar out of normal flow, so nothing
    // reserves space for it — whatever section content happens to sit at
    // the bottom of the viewport when it appears (e.g. the UGC
    // carousel's arrows) ends up visually and interactively underneath
    // it. Reserving exactly the bar's own height as body padding, only
    // while it's actually visible, keeps page content from ever
    // scrolling into the space the fixed bar occupies.
    const observer = new IntersectionObserver(
      ([entry]) => {
        // !entry.isIntersecting alone is true in two opposite cases: the
        // button has been scrolled past (above the viewport) — the only
        // one that should show the bar — AND the button hasn't been
        // reached yet (below the fold on page load, before any scrolling,
        // since the button typically starts below the viewport on a
        // product page). boundingClientRect tells them apart: only a
        // negative bottom means the button's actual position is above the
        // viewport, i.e. scrolled past going down.
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
        stickyBar.setAttribute('aria-hidden', String(!scrolledPast));
        document.body.style.paddingBottom = scrolledPast ? `${stickyBar.offsetHeight}px` : '';
      },
      { threshold: 0 }
    );
    observer.observe(addToCartButton);

    const ctaButton = stickyBar.querySelector('[data-sticky-add-to-cart-cta]');
    if (ctaButton) {
      ctaButton.addEventListener('click', () => {
        const scrollTarget = document.querySelector('.product-bundle') || addToCartButton;
        scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  })();

  function updateCartBadge(form) {
    return fetch(`${form.dataset.cartUrl}.js`)
      .then((response) => response.json())
      .then((cart) => {
        const cartLink = document.querySelector(`a[href="${form.dataset.cartUrl}"]`);
        if (!cartLink) return;
        let badge = cartLink.querySelector('sup');
        if (!badge) {
          badge = document.createElement('sup');
          cartLink.prepend(badge);
        }
        badge.textContent = cart.item_count;
      });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();

    const submitButton = form.querySelector('[data-add-to-cart]');
    const message = form.querySelector('[data-cart-message]');
    const addingText = submitButton.getAttribute('data-adding-text');
    const addText = submitButton.getAttribute('data-add-text');

    submitButton.disabled = true;
    submitButton.textContent = addingText;
    message.removeAttribute('data-state');
    message.textContent = '';

    const activeTier = getActiveTier(form);
    const activeRadio = activeTier ? activeTier.querySelector('[data-bundle-tier-radio]') : null;
    const quantity = activeRadio ? Number(activeRadio.getAttribute('data-quantity')) || 1 : 1;

    let fetchBody;
    let extraHeaders = {};

    if (activeTier) {
      // Bundle mode (every tier, 1x included): one line item per row, each
      // at its own resolved variant ID and quantity 1 — not a single
      // variant added at quantity N — so different colors/sizes across a
      // pack become separate cart lines, and 1x resolves through the exact
      // same mechanism as a single-row "pack".
      const variantsData = getVariantsData(form);
      const tierLabelEl = activeTier.querySelector('.product-bundle__label');
      const tierLabel = tierLabelEl ? tierLabelEl.textContent.trim() : '';
      const items = [];
      let hasUnavailableRow = false;

      activeTier.querySelectorAll('[data-bundle-row]').forEach((row) => {
        const resolved = resolveRowVariant(variantsData, row);
        if (!resolved || !resolved.available) {
          hasUnavailableRow = true;
          return;
        }
        items.push({ id: resolved.id, quantity: 1, properties: { Pack: tierLabel } });
      });

      if (hasUnavailableRow || items.length !== quantity) {
        message.setAttribute('data-state', 'error');
        message.textContent = form.dataset.bundleUnavailableText;
        submitButton.disabled = false;
        submitButton.textContent = addText;
        return;
      }

      fetchBody = JSON.stringify({ items });
      extraHeaders = { 'Content-Type': 'application/json' };
    } else {
      fetchBody = new FormData(form);
    }

    fetch(`${form.dataset.cartAddUrl}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', ...extraHeaders },
      body: fetchBody,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          message.setAttribute('data-state', 'error');
          message.textContent = data.description || data.message;
          return;
        }

        return updateCartBadge(form);
      })
      .catch(() => {
        message.setAttribute('data-state', 'error');
      })
      .finally(() => {
        submitButton.disabled = false;
        submitButton.textContent = addText;
      });
  });
